/* plan-sticky.js — the buy bar that follows you down the page.

   The theme's own sticky ATC bar pointed its button at
   `form="product-form-…__main"`, a form this template no longer renders, so it
   was a button attached to nothing. This one borrows the hero's real form by
   id, which means one form, one source of truth for the variant, and both
   actions behave exactly as they do in the hero. */
(function () {
  'use strict';

  var HIDE_MS = 280;

  var bar = document.querySelector('[data-plan-sticky]');
  var anchor = document.querySelector('[data-plan-sticky-anchor]');
  if (!bar || !anchor || !('IntersectionObserver' in window)) return;

  function show() {
    bar.hidden = false;
    requestAnimationFrame(function () { bar.classList.add('is-up'); });
  }

  function hide() {
    bar.classList.remove('is-up');
    setTimeout(function () {
      if (!bar.classList.contains('is-up')) bar.hidden = true;
    }, HIDE_MS);
  }

  new IntersectionObserver(function (entries) {
    var e = entries[entries.length - 1];
    // Only once the hero's button has gone UP past the top — appearing while
    // someone is still above the hero would be the bar competing with itself.
    if (!e.isIntersecting && e.boundingClientRect.top < 0) show();
    else hide();
  }, { threshold: 0 }).observe(anchor);
})();
